import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dot-label',
  template: ` <div class="tw-flex tw-flex-row tw-items-center">
    <i class="fa-solid fa-circle tw-text-[8px]" [style.color]="color"></i>
    <div class="">
      <span class="tw-ml-2">{{ label }}</span>
    </div>
  </div>`,
  styles: [],
})
export class DotLabelComponent {
  @Input()
  label: string;

  @Input()
  color = 'var(--sed-sedgwick-green-color)';
}
